export const INTEGRATION_STATUS = {
  ENABLED: 'ENABLED',
  DISABLED: 'DISABLED',
  INITIALIZING: 'INITIALIZING',
  QUEUED: 'QUEUED',
  SYNCING: 'SYNCING',
  ERROR: 'ERROR',
  ERROR_OAUTH: 'ERROR_OAUTH',
  ERROR_BILLING: 'ERROR_BILLING',
  ERROR_CONFIG: 'ERROR_CONFIG',
  LOCATION_MAPPING: 'LOCATION_MAPPING',
  USER_MAPPING: 'USER_MAPPING',
  SHIFT_IMPORT: 'SHIFT_IMPORT',
};

export const INTEGRATION_MODAL = {
  [INTEGRATION_STATUS.ENABLED]: [
    'Success!',
    (name, firstSync) => {
      if (firstSync) {
        return `Your Sling and ${name} accounts are now connected!`;
      }

      return `You've successfully synced with ${name}!`;
    },
  ],
  [INTEGRATION_STATUS.INITIALIZING]: [
    'Sit tight...',
    (name) =>
      `We are importing your data from ${name}!\nYou can navigate away from this page - importing \n won't be affected.`,
  ],
  [INTEGRATION_STATUS.ERROR]: [
    'Something went wrong',
    (name) => `Unfortunately something went wrong while syncing with ${name}.`,
  ],
  [INTEGRATION_STATUS.ERROR_BILLING]: [
    'Something went wrong',
    (name) =>
      `Unfortunately there's a problem with your billing on ${name}.\nReconnect your integration to resolve this issue.`,
  ],
  [INTEGRATION_STATUS.SHIFT_IMPORT]: [
    'Sit tight...',
    (name) => `We are syncing data from your ${name} account!`,
  ],
};

INTEGRATION_MODAL[INTEGRATION_STATUS.QUEUED] = INTEGRATION_MODAL.INITIALIZING;
INTEGRATION_MODAL[INTEGRATION_STATUS.SYNCING] = INTEGRATION_MODAL.INITIALIZING;
INTEGRATION_MODAL[INTEGRATION_STATUS.ERROR_OAUTH] = INTEGRATION_MODAL.ERROR;
INTEGRATION_MODAL[INTEGRATION_STATUS.ERROR_BILLING] = INTEGRATION_MODAL.ERROR_BILLING;

export const INTEGRATIONS_DETAILS = {
  shopify: [
    {
      type: 'sync',
      title: 'Employees',
      sref: 'dashboard.manage.users.list',
      description:
        'are imported from your Shopify store account and any changes to their profiles are synced to Sling.',
    },
    {
      type: 'sync',
      title: 'Locations',
      sref: 'dashboard.manage.locations.list',
      description:
        'are imported from your Shopify store account and any changes to your locations are synced to Sling.',
    },
    {
      type: 'sync',
      title: 'Sales',
      sref: 'reports',
      description:
        'are imported from your Shopify store account and reflected across appropriate dates and locations.',
    },
  ],
  square: [
    {
      type: 'sync',
      title: 'Employees',
      sref: 'dashboard.manage.users.list',
      description:
        'are imported from your Square account and any changes to their profiles are synced to Sling.',
    },
    {
      type: 'sync',
      title: 'Timesheets',
      sref: 'timeclock',
      description:
        'are imported from Square account and any changes to timesheets are synced to Sling.',
    },
    {
      type: 'sync',
      title: 'Sales',
      sref: 'reports',
      description:
        'are imported from your Square account and any changes to sales are synced to Sling.',
    },
  ],
  shift4: [
    {
      type: 'sync',
      title: 'Employees',
      sref: 'dashboard.manage.users.list',
      description:
        'are imported from your Shift4 account and any changes to their profiles are synced to Sling.',
    },
    {
      type: 'sync',
      title: 'Timesheets',
      sref: 'timeclock',
      description:
        'are imported from Shift4 account and any changes to timesheets are synced to Sling.',
    },
    {
      type: 'sync',
      title: 'Sales',
      sref: 'reports',
      description:
        'are imported from your Shift4 account and any changes to sales are synced to Sling.',
    },
  ],
  shift4_harbortouch: [
    {
      type: 'sync',
      title: 'Employees',
      sref: 'dashboard.manage.users.list',
      description:
        'are imported from your Harbortouch account and any changes to their profiles are synced to Sling.',
    },
    {
      type: 'sync',
      title: 'Timesheets',
      sref: 'timeclock',
      description:
        'are imported from Harbortouch account and any changes to timesheets are synced to Sling.',
    },
    {
      type: 'sync',
      title: 'Sales',
      sref: 'reports',
      description:
        'are imported from your Harbortouch account and any changes to sales are synced to Sling.',
    },
  ],
  shift4_positouch: [
    {
      type: 'sync',
      title: 'Employees',
      sref: 'dashboard.manage.users.list',
      description:
        'are imported from your POSitouch account and any changes to their profiles are synced to Sling.',
    },
    {
      type: 'sync',
      title: 'Timesheets',
      sref: 'timeclock',
      description:
        'are imported from POSitouch account and any changes to timesheets are synced to Sling.',
    },
    {
      type: 'sync',
      title: 'Sales',
      sref: 'reports',
      description:
        'are imported from your POSitouch account and any changes to sales are synced to Sling.',
    },
  ],
  shift4_restaurant_manager: [
    {
      type: 'sync',
      title: 'Employees',
      sref: 'dashboard.manage.users.list',
      description:
        'are imported from your Restaurant Manager account and any changes to their profiles are synced to Sling.',
    },
    {
      type: 'sync',
      title: 'Timesheets',
      sref: 'timeclock',
      description:
        'are imported from Restaurant Manager account and any changes to timesheets are synced to Sling.',
    },
    {
      type: 'sync',
      title: 'Sales',
      sref: 'reports',
      description:
        'are imported from your Restaurant Manager account and any changes to sales are synced to Sling.',
    },
  ],
  toast: [
    {
      type: 'sync',
      title: 'Employees',
      sref: 'dashboard.manage.users.list',
      description:
        'are imported from your Toast account and any changes to their profiles are synced to Sling.',
    },
    {
      type: 'sync',
      title: 'Timesheets',
      sref: 'timeclock',
      description:
        'are imported from your Toast account and any changes to timesheets are synced to Sling.',
    },
    {
      type: 'sync',
      title: 'Sales',
      sref: 'reports',
      description:
        'are imported from your Toast account and any changes to sales are synced to Sling.',
    },
  ],
};

export const INTEGRATIONS_INFO = {
  shopify: {
    imported: 'Employees • Locations • Sales',
  },
  square: {
    imported: 'Employees • Sales • Timesheets',
  },
  shift4: {
    imported: 'Employees • Sales • Timesheets',
  },
};

// This also defines order of integrations on the list
export const POS_TYPES = ['toast', 'square', 'shopify', 'shift4'];

export const CODE_CONNECT_INTEGRATIONS = {
  toast: {
    description:
      'Head to Toast and paste the partner group ID below under the location you want to connect to Sling.',
    learnMoreUrl: 'https://support.getsling.com/en/articles/5041180-sling-and-toast',
    connectUrl: null,
  },
};
